import { render, staticRenderFns } from "./soluution_static.vue?vue&type=template&id=2fe6989d&scoped=true"
import script from "./soluution_static.vue?vue&type=script&lang=js"
export * from "./soluution_static.vue?vue&type=script&lang=js"
import style0 from "./soluution_static.vue?vue&type=style&index=0&id=2fe6989d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6989d",
  null
  
)

export default component.exports